<div class="row text-center animated fadeIn">
  <div class="col">
    <i class="fa fa-sync fa-5x fa-spin"></i>
    <br>
    Cargando...
  </div>
</div>
<!--<div class="row">
  <div class="col-12">
      <div class="alert alert-info text-center">
          <h4 class="alert-heading">Cargando</h4>
          <i class="fa fa-sync fa-spin fa-3x"></i>
          <p class="mb-0">Espera por favor...</p>
      </div>
  </div>
</div>-->

